import styled from 'styled-components';

export const JobDetailWrapper = styled.div`
  .read-more {
    &__button {
      color: ${({ theme }) => theme.palette.green};
    }
  }
`;
